import Button from "components/Button";
import { SettingsTabs } from "components/Settings/SettingsModal";
import ModalsManagerContext from "contexts/ModalsManager";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import NotaIcon from "assets/icons/notaicon.svg?react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

/**
 * Widok podglądu przesyłki przychodzącej zablokowanej do czasu zwiększenia pakietu.
 * Wariant "payment" — przekroczony limit darmowych przesyłek (ContactMessage.IsPendingPayment);
 * wariant "storage" — brak miejsca na dysku (ContactMessage.IsPendingStorage).
 * Zamiast treści wiadomości pokazuje informację o blokadzie, a przycisk „Zwiększ pakiet"
 * otwiera Ustawienia → Płatności (zarządzanie pakietem).
 */
const PendingPaymentModal: FC<Props> = ({ variant = "payment" }) => {
  const { t } = useTranslation();
  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);

  const keyBase =
    variant === "storage" ? "packages.pendingStorage" : "packages.pendingPayment";

  const handleUpgrade = () => {
    setOptions({ initialTab: SettingsTabs.Payments });
    setModals({ ...modals, settings: true });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.modal}>
        <NotaIcon className={styles.logo} />
        <div className={styles.title}>{t(`${keyBase}.title`)}</div>
        <div className={styles.description}>
          <p>{t(`${keyBase}.line1`)}</p>
          <p>{t(`${keyBase}.line2`)}</p>
        </div>
        <Button
          className={styles.button}
          text={t("packages.pendingPayment.upgrade")}
          onClick={handleUpgrade}
        />
      </div>
    </div>
  );
};

export default PendingPaymentModal;
